<!--
 * @Description: 国际化单页，英文日文
 * @Author: pliybird
 * @Date: 2025-10-10 15:41:37
 * @LastEditTime: 2025-10-24 11:28:37
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
  <Layout :footerStyle="2" :showHeader="false" class="single-home">
    <SingleHeader />

    <section class="rn-section-gap bg-vyung-gray pb--0">
      <div class="container">
        <SectionTitle
          title="Microsoft Business Application"
          :sectionTitleStyle="3"
          textAlign="center"
          data-aos="fade-up"
          data-aos-delay="60"
        />
        <div class="bg-white mbapadding">
          <img src="@/assets/images/singleHome/dynamics-365.png" alt="" />
        </div>
      </div>
    </section>

    <!-- Dynamics 365 -->
    <section class="dynamics-365 bg-vyung-gray pt--50">
      <div class="container">
        <SectionTitle
          :title="$t('single_home.crm_service.title')"
          :sectionTitleStyle="3"
          :description="$t('single_home.crm_service.desc')"
          textAlign="center"
          data-aos="fade-up"
          data-aos-delay="60"
        />
        <animated-tabs :tabs="crmTabsData" indicatorWidth="60px">
          <template #default="{ activeIndex }">
            <tab-content
              :tabData="crmTabsData[activeIndex]"
              :src="
                require(`@/assets/images/singleHome/crm_sales${
                  activeIndex + 1
                }.png`)
              "
            />
          </template>
        </animated-tabs>
      </div>
    </section>

    <!-- Dynamics ERP -->
    <section class="dynamics-erp pt--50 bg-vyung-gray">
      <div class="container">
        <SectionTitle
          :title="$t('single_home.erp_service.title')"
          :sectionTitleStyle="3"
          :description="$t('single_home.erp_service.desc')"
          textAlign="center"
          data-aos="fade-up"
          data-aos-delay="60"
        />
        <animated-tabs :tabs="erpTabsData" indicatorWidth="60px">
          <template #default="{ activeIndex }">
            <tab-content
              :tabData="erpTabsData[activeIndex]"
              :src="
                require(`@/assets/images/singleHome/erp_service${
                  activeIndex + 1
                }.png`)
              "
            />
          </template>
        </animated-tabs>
      </div>
    </section>

    <!-- Power Platform -->
    <section class="power-platform pt--50 bg-vyung-gray pb--50">
      <div class="container">
        <SectionTitle
          :title="$t('single_home.pp_service.title')"
          :sectionTitleStyle="3"
          :description="$t('single_home.pp_service.desc')"
          textAlign="center"
          data-aos="fade-up"
          data-aos-delay="60"
        />
        <animated-tabs :tabs="ppTabsData" indicatorWidth="60px">
          <template #default="{ activeIndex }">
            <tab-content
              :tabData="ppTabsData[activeIndex]"
              :src="
                require(`@/assets/images/singleHome/pp_service${
                  activeIndex + 1
                }.png`)
              "
            />
          </template>
        </animated-tabs>
      </div>
    </section>

    <!-- IP Product -->
    <section class="ip-product bg-white pt--50 pb--50">
      <div class="container">
        <SectionTitle
          :title="$t('single_home.ip_service.title')"
          :sectionTitleStyle="3"
          textAlign="center"
          data-aos="fade-up"
          data-aos-delay="60"
        />
        <div class="row row-gutter-50">
          <div class="col-lg-8 col-md-8 col-sm-12">
            <h4 class="bottom_line">
              {{ $t("single_home.ip_service.sub_title") }}
            </h4>
            <p>{{ $t("single_home.ip_service.desc") }}</p>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <Video :video-data="videoData" :videoStyle="1" column="col-12" />
          </div>
          <div
            v-for="(item, index) in $t('single_home.ip_service.list')"
            :key="index"
            class="col-lg-4 col-md-4 col-sm-12"
          >
            <div class="row align-items-center justify-content-start">
              <svg-icon class="iconfont" :iconClass="`Product-0${index + 1}`" />
              <h5 class="mb-0 pl--0 flex-1">{{ item.title }}</h5>
            </div>
            <p>{{ item.desc }}</p>
          </div>
        </div>
        <div class="gtc">
          <div class="title mb--30">
            <h2>{{ $t("single_home.ip_service.gtc.title") }}</h2>
          </div>
          <VueSlickCarousel v-bind="gtcSliderSettings">
            <div
              v-for="(item, index) in $t('single_home.ip_service.gtc.list')"
              :key="index"
              class="slider-item"
            >
              <div class="row justify-content-between align-items-center">
                <h4 class="flex-1 mb-0">{{ item.title }}</h4>
                <svg-icon class="iconfont" :iconClass="`gtc-${index + 1}`" />
              </div>
              <p>{{ item.desc }}</p>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </section>

    <!-- Cases -->
    <section class="rwt-split-area rn-section-gap cases">
      <div class="container">
        <SectionTitle
          :title="$t('single_home.case.title')"
          :sectionTitleStyle="1"
          textAlign="center"
          data-aos="fade-up"
          data-aos-delay="60"
        />
        <div class="row row-gutter-50">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="case-item">
              <div class="title mb--10">{{ $t("single_home.case.erp") }}</div>
              <div class="row row-gutter-15 p-4">
                <div
                  v-for="(item, index) in erpList"
                  :key="index"
                  class="col-4 img-item"
                >
                  <div class="img">
                    <img :src="item" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="case-item">
              <div class="title mb--10">{{ $t("single_home.case.crm") }}</div>
              <div class="row row-gutter-15 p-4">
                <div
                  v-for="(item, index) in crmList"
                  :key="index"
                  class="col-4 img-item"
                >
                  <div class="img">
                    <img :src="item" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- About Us -->
    <section
      class="rn-section-gap about-us"
      :style="`
        background-image:url(${require('@/assets/images/singleHome/about_us_bg.png')});
        background-size: 60%;
        background-position: top right;
        background-repeat: no-repeat;
      `"
    >
      <div class="container">
        <SectionTitle
          :title="$t('single_home.about_us.title')"
          :sectionTitleStyle="3"
          :description="`<span class='w-500 text-indent-2em d-inline-block'>${$t(
            'single_home.about_us.desc'
          )}</span>`"
          textAlign="center"
          data-aos="fade-up"
          data-aos-delay="60"
        />
        <div class="row align-items-end justify-content-center">
          <div class="col-lg-3 col-md-3 col-sm-12 h-300">
            <div class="d-flex align-items-center flex-column">
              <img src="@/assets/images/singleHome/about_us1.png" alt="" />
              <h5 class="plr--30 text-center mb-3">
                {{ $t("single_home.about_us.list[0]") }}
              </h5>
              <div class="shape"></div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 h-300">
            <div class="d-flex align-items-center flex-column">
              <div class="row">
                <div class="col-4">
                  <img src="@/assets/images/singleHome/about_us2.png" alt="" />
                </div>
                <div class="col-4">
                  <img src="@/assets/images/singleHome/about_us3.png" alt="" />
                </div>
                <div class="col-4">
                  <img src="@/assets/images/singleHome/about_us4.png" alt="" />
                </div>
              </div>
              <h5 class="plr--30 box-wrap text-center mb-3">
                {{ $t("single_home.about_us.list[1]") }}
              </h5>
              <div class="shape"></div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 h-300">
            <div class="d-flex align-items-center flex-column">
              <img src="@/assets/images/singleHome/about_us5.png" alt="" />
              <h5 class="plr--30 text-center mb-4 mt-5">
                {{ $t("single_home.about_us.list[2]") }}
              </h5>
              <div class="shape"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="rwt-counterup-area relative pb--50">
      <div class="container">
        <Counter
          :counter-style="5"
          text-align="center"
          column="col-lg-3 col-md-6 col-sm-6 col-12"
        />
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/components/common/Layout";
import SingleHeader from "./components/SingleHeader.vue";
import Counter from "@/components/elements/counterUp/Counter.vue";
import SectionTitle from "@/components/elements/sectionTitle/SectionTitle";
import AnimatedTabs from "./components/AnimatedTabs.vue";
import TabContent from "./components/TabContent.vue";
import SvgIcon from "@/components/svgIcon";
import VueSlickCarousel from "vue-slick-carousel";
import Video from "@/components/elements/video/Video";

export default {
  name: "SinglePageHome",
  components: {
    Layout,
    SingleHeader,
    Counter,
    SectionTitle,
    AnimatedTabs,
    TabContent,
    SvgIcon,
    VueSlickCarousel,
    Video,
  },
  data() {
    return {
      gtcSliderSettings: {
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnDotsHover: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              autoplay: true,
              arrows: false,
            },
          },
        ],
      },
      videoData: [
        {
          src:
            process.env.VUE_APP_VIDEO_URL +
            "/$web/video/workflow.mp4?" +
            process.env.VUE_APP_VIDEO_RAXWDL,
          thumb: require(`@/assets/images/ProductService/VyungWorkflow/workflow_tumb.png`),
        },
      ],
    };
  },
  created() {
    const requeireErpContext = require.context(
      "@/assets/images/singleHome/erp",
      false,
      /\.png|jpg$/
    );
    const requeireCrmContext = require.context(
      "@/assets/images/singleHome/crm",
      false,
      /\.png|jpg$/
    );
    this.erpList = this.handleCaseImgs(requeireErpContext);
    this.crmList = this.handleCaseImgs(requeireCrmContext);
  },
  computed: {
    crmTabsData() {
      return this.$t("single_home.crm_service.content");
    },
    erpTabsData() {
      return this.$t("single_home.erp_service.content");
    },
    ppTabsData() {
      return this.$t("single_home.pp_service.content");
    },
  },

  methods: {
    handleCaseImgs(context) {
      return context.keys().reduce((acc, key) => {
        const name = key.replace("./", "");
        acc[name] = context(key);
        return acc;
      }, {});
    },
  },
};
</script>



